/**
 * Known keys. You don't need to import this as you would still be able to use normalized string.
 * @module keyboard/keys
 */
export const Keys = {
    BACKSPACE: 'Backspace',
    DOWN: 'Down',
    END: 'End',
    ENTER: 'Enter',
    ESCAPE: 'Escape',
    HOME: 'Home',
    LEFT: 'Left',
    PAGEDOWN: 'PageDown',
    PAGEUP: 'PageUp',
    RIGHT: 'Right',
    SHIFT: 'Shift',
    SPACE: 'Space',
    TAB: 'Tab',
    UP: 'Up',
};
